import {
  ApplicationRef,
  ComponentRef,
  EnvironmentInjector,
  Injectable,
  createComponent,
  inject,
} from '@angular/core';
import { ToastComponent } from '../components/toast/toast.component';
export type ToastPosition = 'bottom-left' | 'bottom-right' | 'top-left' | 'top-right';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private appRef = inject(ApplicationRef);
  private environmentInjector = inject(EnvironmentInjector);
  show(
    messageKey: string,
    type: 'success' | 'error' | 'warning' | 'info',
    duration = 5000,
    showCloseButton = false,
    titleKey = '',
    position?: ToastPosition
  ) {
    const toastRef: ComponentRef<ToastComponent> = createComponent(ToastComponent, {
      environmentInjector: this.environmentInjector,
    });
    toastRef.instance.message = messageKey;
    toastRef.instance.title = titleKey;
    toastRef.instance.type = type;
    toastRef.instance.showCloseButton = showCloseButton;
    toastRef.instance.duration = duration;
    if (position) toastRef.instance.position = position;
    this.appRef.attachView(toastRef.hostView);
    const domElem = (toastRef.hostView as any).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);
    toastRef.instance.closed.subscribe(() => {
      this.appRef.detachView(toastRef.hostView);
      toastRef.destroy();
    });
  }
}
